import { Business } from 'model';
import GenericBusinessIcon from '../assets/buildingIcon.png';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { getBusinessImages } from '../util/getBusinessImages';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './BusinessHeader.module.css';
import { IconUpload } from './QuirkIcons';
import classNames from 'classnames';
import { IconButton } from './IconButton';
import { QuirkImage } from './QuirkImage.js';
import { useBackendImageURL } from '../hooks/useBackendDomain.js';

export interface BusinessHeaderProps {
	business: Business;
	onEditLogo?: () => void;
	onEditBanner?: () => void;
}

export const BusinessHeader = ({ business, onEditLogo, onEditBanner }: BusinessHeaderProps) => {
	const { logo, banner } = getBusinessImages(business);
	const bannerUrl = useBackendImageURL(banner);
	return (
		<div className={sharedStyles.pageProfileHeader}>
			<div
				className={sharedStyles.pageProfileImage}
				style={
					business.logoBackgroundColor ? { padding: 5, backgroundColor: business.logoBackgroundColor } : {}
				}
			>
				<QuirkImage
					src={logo}
					alt={business.name}
					className={sharedStyles.pageIcon}
					fallback={GenericBusinessIcon}
					contain
				/>
			</div>

			<div
				className={sharedStyles.pageBannerContainer}
				style={{
					backgroundImage: `url(${bannerUrl})`
				}}
			>
				{onEditBanner && (
					<div className={classNames(styles.buttonLink, styles.buttonLinkCover)} onClick={onEditBanner}>
						<span>Edit cover</span>
						<IconUpload />
					</div>
				)}
			</div>
			<div className="space40" />
			{onEditLogo && <IconButton label="Edit logo" icon={<IconUpload />} onClick={onEditLogo} iconRight />}
		</div>
	);
};
